import React from "react";
import "../css/home.css";
import { Link } from "react-router-dom";
import TopCategories from "../components/topCategoies";
import ProductsList from "../components/productList";
import ScrollTop from "../components/scrollTop";

export default function Home() {
    return (
        <>
            <ScrollTop />
            <div className="banner-section">
                <Link to="/category/home-essentials/home-furniture">
                    <img src="/images/banners/banner.png" alt="" className="img-fluid" />
                </Link>
            </div>
            <div className="container">
                <TopCategories />
                <h3 className="section-title fw-bold fs-2" style={{ marginBottom: '-50px', marginLeft: '20px' }}>Featured Products</h3>
                <ProductsList />

                <div className="row mb-5">
                    <div className="col-md-6 mb-3 mb-md-0">
                        <Link to="/category/personal-care/skin-care">
                            <img src="/images/banners/skin-care.png" alt="Skin Care" className="img-fluid rounded" />
                        </Link>
                    </div>
                    <div className="col-md-6">
                        <Link to="/category/pets-care">
                            <img src="/images/banners/pets-care.png" alt="Pets Care" className="img-fluid rounded" />
                        </Link>
                    </div>
                </div>

                <h3 className="section-title fw-bold fs-2" style={{ marginBottom: '-50px', marginLeft: '20px' }}>Skin Care</h3>
                <ProductsList category="Personal Care" subcategory="Skin Care" />

                <h3 className="section-title fw-bold fs-2" style={{ marginBottom: '-50px', marginLeft: '20px' }}>Pets Care</h3>
                <ProductsList category="Pets Care" />
            </div>
            <div className="banner-container">
                <div className="banner-left">
                    <div className="discount-label">
                        <span>ONLY THIS WEEK</span>
                        <h2>UP TO 20% OFF</h2>
                    </div>
                    <img
                        src="/images/banners/banner1.jpg"
                        alt="Furniture"
                        className="banner-img"
                    />
                </div>

                {/* --- UPDATED SECTION to match the image --- */}
                <div className="banner-right modern-style">

                    {/* Pre-heading text */}
                    <span className="modern-heading">MAKE LIFE EASIER</span>

                    <h1 className="modern-title">
                        Smart
                        <br />
                        Home Appliances
                    </h1>

                    <p className="modern-subtitle">
                        Upgrade your daily living with our latest range!
                    </p>

                    <Link to="/category/home-essentials/home-appliances">
                        <button className="modern-button">Shop Now</button>
                    </Link>
                </div>
            </div>
            <div className="container mt-5">
                <h3 className="section-title fw-bold fs-2" style={{ marginBottom: '-50px', marginLeft: '20px' }}>SaaS</h3>
                <ProductsList category="SaaS" />
            </div>
        </>

    );
}